module.exports = __webpack_public_path__ + "static/media/fitness.6017ac65.mp4";